import classNames from 'classnames';
import { useI18n } from '@/libraries/contexts/i18n-context';
import * as SpecialHotelBadges from '@/assets/graphics/specialHotelTypes/specialHotelTypes';
import styles from './special-hotel-badge.module.scss';

export interface SpecialHotelBadgeProps {
  /** The class name to apply */
  className?: string;
  /** The type of the image to show */
  type: Content.Components['SpecialHotelType'];
}

const SpecialHotelBadge = ({ className, type }: SpecialHotelBadgeProps) => {
  const { t } = useI18n();

  const SpecialHotelBadge = SpecialHotelBadges[type];

  if (!SpecialHotelBadge) {
    return null;
  }

  const getAccessibleLabel = (
    badgeType: Content.Components['SpecialHotelType'],
  ): string => {
    const labels: Record<Content.Components['SpecialHotelType'], string> = {
      BravoDeluxe: t('items.search.productCard.conceptHotelDeluxe'),
      BravoDuo: t('items.search.productCard.conceptHotelDuo'),
      BravoFavorit: t('items.search.productCard.conceptHotelFavorite'),
      BravoLokal: t('items.search.productCard.conceptHotelLocal'),
      BravoUnik: t('items.search.productCard.conceptHotelUnique'),
      Default: '',
      HeartHotel: t('items.search.productCard.heartHotelLogo'),
    };

    return labels[badgeType] || `${badgeType} ${t('items.common.words.hotel')}`;
  };

  return (
    <div
      aria-label={getAccessibleLabel(type)}
      className={classNames(styles.component, className)}
      role={'presentation'}
    >
      <SpecialHotelBadge
        className={styles.badge}
        focusable="false"
        preserveAspectRatio="xMidYMid meet"
      />
    </div>
  );
};

SpecialHotelBadge.displayName = 'SpecialHotelBadge';

export default SpecialHotelBadge;
